import React from "react";
import "./App.css";
import { Route, Switch } from "react-router-dom";

import AuthenticationProvider from "./auth-provider";
import AuthRequired from "./AuthRequired";
import Logout from './screens/Logout/Logout';

// import useAuth from "./use-auth";

import Addsurveyor from "./screens/Homescreen/Main";

const client_id = process.env.REACT_APP_VSNMSAS_CLIENT_ID_VAL
  ? process.env.REACT_APP_VSNMSAS_CLIENT_ID_VAL
  : "";
const provider = process.env.REACT_APP_SSO_IDENTITY_PROVIDER_BASEPATH_VAL
  ? process.env.REACT_APP_SSO_IDENTITY_PROVIDER_BASEPATH_VAL
  : "";
const tokenEndpoint = process.env
  .REACT_APP_VSNMSAS_PROVIDER_TOKEN_ENDPOINT_VAL
  ? process.env.REACT_APP_VSNMSAS_PROVIDER_TOKEN_ENDPOINT_VAL
  : "";
const authorizationEndpoint = process.env
  .REACT_APP_VSNMSAS_PROVIDER_AUTH_ENDPOINT_VAL
  ? process.env.REACT_APP_VSNMSAS_PROVIDER_AUTH_ENDPOINT_VAL
  : "";
const redirect_uri = process.env.REACT_APP_VSNMSAS_REDIRECT_URI_VAL
  ? process.env.REACT_APP_VSNMSAS_REDIRECT_URI_VAL
  : "";
const grant_type = process.env.REACT_APP_GRANT_TYPE_VAL
  ? process.env.REACT_APP_GRANT_TYPE_VAL
  : "";
const ProtectedComponent = () => {
  // const auth = useAuth();
  // const { access_token } = auth.token;

  // return(<div>You have logged in successfully! token = {access_token}</div>) ;
  return (
    <div>
      <Switch>
        <Route path="/" component={Addsurveyor} exact />
        <Route path='/logout' component={Logout} exact />
      </Switch>
    </div>
  );
};
const App = () => {
  return (
    <>
      <AuthenticationProvider
        client_id={client_id}
        provider={provider}
        authorizationEndpoint={authorizationEndpoint}
        tokenEndpoint={provider + tokenEndpoint}
        redirect_uri={redirect_uri}
        grant_type={grant_type}
      >
        <AuthRequired>
          <ProtectedComponent></ProtectedComponent>
        </AuthRequired>
      </AuthenticationProvider>
     
    </>
  );
};

export default App;
